<a class="cell shrink grid-x" [routerLink]="['/']">
    <img class="cell shrink appHeader-logo" src="./assets/images/svg/4shared-devices-logo.svg" alt="4SharedDevices">
    <a-api-info-display class="cell shrink appHeader-versionNumber"></a-api-info-display>
</a>
